export enum RequiredShiftsPendingChanges {
  Insert = 'Insert',
  Delete = 'Delete'
}
